import { IFormHandler } from "./forms";

export interface ICustomCategoryForm {
    parentCategoryId: string;
    name: string;
    code: string;
    isGlobal: boolean;
}

export interface ICustomCategoryRequest {
    name: string;
    code: string;
    is_global: boolean;
    parent_category_id?: number | null;
}

export class CustomCategoryForm implements IFormHandler<ICustomCategoryForm, ICustomCategoryRequest> {
    public readonly initialValue: ICustomCategoryForm;

    constructor(data?: ICustomCategoryRequest) {
        this.initialValue = this.toForm(data);
    }

    toForm(data?: ICustomCategoryRequest): ICustomCategoryForm {
        if (!data) {
            return {
                parentCategoryId: '',
                name: '',
                code: '',
                isGlobal: false,
            };
        }

        return {
            parentCategoryId: data.parent_category_id?.toString() || '',
            name: data.name,
            code: data.code,
            isGlobal: data.is_global,
        };
    }

    toRequest(data: ICustomCategoryForm): ICustomCategoryRequest {
        return {
            parent_category_id: parseInt(data.parentCategoryId),
            name: data.name,
            code: data.code,
            is_global: data.isGlobal,
        };
    }
}
